export default {
  title: 'Impresión de recibos',
  sections: {
    destination: 'Los recibos se imprimen en',
  },
  printers: {
    inner: {
      title: 'Impresora integrada',
    },
    external: {
      title: 'Impresora externa',
      width_unset: 'Ancho de papel no configurado',
      connect_hint: 'Conecta una impresora para usarla',
      disconnect_confirm: '¿Desconectar esta impresora?',
      disconnect_confirm_description: 'Tendrás que configurarla de nuevo.',
      disconnect_confirm_ok: 'Sí, desconectar',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Lista',
      title: 'Lista para imprimir',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Papel bajo',
      title: 'El papel está casi agotado',
      description: 'Cambia el rollo pronto. La impresión continúa.',
    },
    busy: {
      label: 'Ocupada',
      title: 'Impresora ocupada',
      description: '{{name}} está terminando otro trabajo.',
    },
    not_configured: {
      label: 'Sin configurar',
      title: 'Sin configurar',
      description: '{{name}} debe configurarse antes de poder imprimir.',
    },
    offline: {
      label: 'Sin conexión',
      title: 'No imprime',
      description: '{{name}} está desconectada. Los nuevos pedidos no se imprimen.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Sin conexión',
      description_idle: '{{name}} no está conectada.',
    },
    cover_open: {
      label: 'Tapa abierta',
      title: 'La tapa está abierta',
      description: 'Cierra la tapa de la impresora para reanudar la impresión.',
    },
    paper_empty: {
      label: 'Sin papel',
      title: 'Sin papel',
      description: 'Cambia el rollo para reanudar la impresión.',
    },
    wrong_paper: {
      label: 'Papel incorrecto',
      title: 'Papel incorrecto',
      description: 'El rollo cargado no coincide con el ancho de papel configurado.',
    },
    cutter_error: {
      label: 'Error del cortador',
      title: 'Error del cortador',
      description: 'Comprueba si hay papel atascado en el cortador e inténtalo de nuevo.',
    },
    overheat: {
      label: 'Demasiado caliente',
      title: 'Impresora demasiado caliente',
      description: 'Deja que {{name}} se enfríe antes de volver a imprimir.',
    },
    error: {
      label: 'Error',
      title: 'Error de impresora',
      description: '{{name}} ha informado de un error y necesita atención.',
    },
    connecting: {
      label: 'Conectando…',
      title: 'Conectando…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'No conectada',
      title: 'No conectada',
      description: '{{name}} no está conectada.',
    },
  },
  form: {
    auto_print: {
      label: 'Imprimir nuevos pedidos automáticamente',
      not_ready:
        'La impresión automática está activada pero la impresora externa no está lista. Los pedidos no se imprimirán.',
    },
    print_copies: {
      label: 'Copias por pedido',
      hint: 'Activa la impresión automática para configurar las copias',
      decrease: 'Reducir copias',
      increase: 'Aumentar copias',
    },
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
  },
  buttons: {
    test_print: 'Impresión de prueba',
    configure_external: 'Configurar',
    connect_external: 'Conectar una impresora',
    disconnect_external: 'Desconectar',
    retry_connection: 'Reintentar conexión',
    cancel: 'Cancelar',
  },
};
